export default __webpack_public_path__ + "static/media/USDottruck.0885a4ed.svg";